import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Spin } from 'antd';
import { UserOutlined, MedicineBoxOutlined, TeamOutlined, FileTextOutlined } from '@ant-design/icons';
import api from '../../services/api';
import { useTranslation } from 'react-i18next';

const Dashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await api.get('/companyseller/stats');
            setStats(response.data.data);
        } catch (error) {
            console.error('Error fetching stats:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>{t('dashboard') || 'Dashboard'}</h1>

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('totalDoctors') || 'Total Doctors'}
                            value={stats?.doctorCount || 0}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#3f8600' }}
                        />
                        <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
                            {t('active') || 'Active'}: {stats?.activeDoctors || 0}
                        </div>
                    </Card>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('doctorLimit') || 'Doctor Limit'}
                            value={stats?.doctorLimit === 'unlimited' ? '∞' : stats?.doctorLimit || 0}
                            prefix={<TeamOutlined />}
                            valueStyle={{ color: '#1890ff' }}
                        />
                        <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
                            {t('remaining') || 'Remaining'}: {stats?.remainingSlots === 'unlimited' ? '∞' : stats?.remainingSlots || 0}
                        </div>
                    </Card>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('totalPatients') || 'Total Patients'}
                            value={stats?.totalPatients || 0}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>

                <Col xs={24} sm={12} lg={6}>
                    <Card>
                        <Statistic
                            title={t('totalVisits') || 'Total Visits'}
                            value={stats?.totalVisits || 0}
                            prefix={<FileTextOutlined />}
                            valueStyle={{ color: '#722ed1' }}
                        />
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                <Col span={24}>
                    <Card title={t('overview') || 'Overview'}>
                        <p>
                            {t('welcomeMessage') || 'Welcome to your Company Seller dashboard. Here you can manage your doctors and view statistics.'}
                        </p>
                        <p>
                            {t('doctorManagementInfo') || 'Use the Doctors menu to create new doctors, view their details, and manage their information.'}
                        </p>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Dashboard;
